import styled from "styled-components/macro";
import { Heading3Css, Heading4 } from "styles/elements/Headings";
import { media } from "styles/media";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const Container = styled.div<Props>`
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  justify-content: space-between;
`;
export const StyleContainer = styled.div<Props>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 24px auto 40px auto;
  max-width: initial;
  width: 80%;
  ${media.tablet} {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  width: 100vw;
  }
`;

export const StyleCategory = styled.div<Props>`
  ${Heading3Css};
  display: block;
  height: auto;
  font-weight: bold;
  line-height: 24px;
  margin: 28px 18px;
  width: 90%;
`;

export const FooterContainer = styled.div<Props>`
  margin-bottom: -3px;
`;
export const StyleImage = styled.img<Props>`
  height: 130px;
  width: 130px;
  margin-top: 20px;
`;

export const StyleTitle = styled(Heading4)<Props>`
margin: 30px 0 20px 0;
`;

export const StyleNoItemsContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
